import { FC } from "react";

import {
  BASE_SIZES,
  SHOES_BASE_SIZES,
} from "../../../../../../constants/modal";
import { font } from "../../../../../../configs";

import ArrowIcon from "../../../../../../assets/icons/ArrowIcon";

import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

interface IPropsGivenchyBaseSizeSelector {
  sizeCountry: string;
  setSizeCountry: React.Dispatch<React.SetStateAction<string>>;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  langDropdownStyles: React.CSSProperties;
}

const GivenchyBaseSizeSelector: FC<IPropsGivenchyBaseSizeSelector> = ({
  sizeCountry,
  setSizeCountry,
  open,
  setOpen,
  langDropdownStyles,
}) => {
  const fontFamily = `${font}, sans-serif`;

  const urlParameters = new URLSearchParams(window.location.search);
  const isFootwear =
    urlParameters.get("category") === "footwear" ||
    urlParameters.get("footwear") === "true";

  const items = isFootwear ? SHOES_BASE_SIZES : BASE_SIZES;

  return (
    <FormControl fullWidth>
      <Select
        role="size-country-select"
        value={sizeCountry}
        onChange={(e) => setSizeCountry(e.target.value)}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        displayEmpty
        IconComponent={(props) => (
          <ArrowIcon
            fill={langDropdownStyles.color as string}
            style={{ transform: open ? "rotate(90deg)" : "rotate(270deg)" }}
            open={open}
            {...props}
          />
        )}
        sx={{
          fontFamily,
          fontSize: langDropdownStyles.fontSize,
          border: `${langDropdownStyles.borderWidth} solid ${langDropdownStyles.borderColor}`,
          borderBottomColor: open
            ? "transparent"
            : langDropdownStyles.borderColor,
          borderRadius: open
            ? `${langDropdownStyles.borderRadius} ${langDropdownStyles.borderRadius} 0 0`
            : langDropdownStyles.borderRadius,
          "& fieldset": {
            border: "none",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              boxShadow: `111px 173px 82px rgba(115, 115, 115, 0.01),
              62px 97px 69px rgba(115, 115, 115, 0.03),
              28px 43px 51px rgba(115, 115, 115, 0.04),
              7px 11px 28px rgba(115, 115, 115, 0.05),
              0px 0px 0px rgba(115, 115, 115, 0.05)`,
              textAlign: "center",
              fontFamily,
              fontSize: langDropdownStyles.fontSize,
              border: `${langDropdownStyles.borderWidth} solid ${langDropdownStyles.borderColor}`,
              borderTopColor: "transparent",
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            },
          },
          MenuListProps: {
            sx: {
              padding: 0,
              fontFamily,
              fontSize: langDropdownStyles.fontSize,
              textAlign: "center",
              "& .Mui-selected": {
                display: "none",
              },
            },
          },
        }}
      >
        {items.map(({ name }) => (
          <MenuItem
            key={name}
            value={name}
            sx={{
              fontFamily,
              fontSize: langDropdownStyles.fontSize,
              height: "30px",
              justifyContent: "left",
            }}
          >
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GivenchyBaseSizeSelector;
